/**
 * Is the current user entitled to Pro?
 *
 * `GET /billing/subscription` returns { active } — true for a paid subscription,
 * an active trial, or an admin-granted comp. Used to gate Pro-only choices in the
 * UI *before* the user hits the backend wall, and to offer them a way to pay.
 */
import { useQuery } from '@tanstack/react-query';
import { billingService } from '../services/billing';

export function useIsPro(): { isPro: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: () => billingService.getSubscription(),
    staleTime: 60_000,
    retry: false,
  });
  return { isPro: data?.active ?? false, isLoading };
}
